import React, { useEffect, useMemo, useState } from 'react';
import { Badge, Button, Card, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { faEye, faFilePdf, faPrint } from '@fortawesome/free-solid-svg-icons';
import ActionIconButton from '../../components/ActionIconButton';
import { addBillingPayment, getBillingHistory, getBillingStudents } from '../../service/apiService';
import logo from '../../assets/company-logo.png';
import './Billing.css';
import Select from "react-select";

const money = (v) => Number(v || 0).toFixed(2);

function UnifiedBilling({ user }) {
  const [type, setType] = useState('admission');
  const [students, setStudents] = useState([]);
  const [studentId, setStudentId] = useState('');
  const [payment, setPayment] = useState({ paid_amount: '', payment_mode: '', remarks: '' });
  const [receipt, setReceipt] = useState(null);
  const [history, setHistory] = useState([]);
  const [filters, setFilters] = useState({ search: '', student_type: '', from_date: '', to_date: '', page: 1, limit: 10 });
  const [pagination, setPagination] = useState({ total_pages: 1 });
 const selected = useMemo(
    () => students.find((s) => Number(s.id) === Number(studentId)),
    [students, studentId]
);
  const currentPayment = Number(payment.paid_amount || 0);
  const newBalance = selected ? Math.max(0, Number(selected.balance || 0) - currentPayment) : 0;

  const loadStudents = async () => {
    const res = await getBillingStudents(type);
    setStudents(res.status === 'success' ? res.data : []);
    setStudentId('');
  };
  const loadHistory = async () => {
    const res = await getBillingHistory(filters);
    if (res.status === 'success') {
      setHistory(res.data || []);
      setPagination(res.pagination || { total_pages: 1 });
    }
  };
  useEffect(() => { loadStudents(); }, [type]);
  useEffect(() => { loadHistory(); }, [filters]);

  const savePayment = async () => {
    if (!selected) return alert('Select student');
    if (!payment.payment_mode) return alert('Select payment mode');
    if (currentPayment <= 0) return alert('Enter valid payment amount');
    if (Number(selected.balance || 0) > 0 && currentPayment > Number(selected.balance)) return alert('Payment cannot exceed remaining balance');
    const res = await addBillingPayment({ student_type: type, student_id: selected.id, paid_amount: currentPayment, payment_mode: payment.payment_mode, remarks: payment.remarks, collected_by: user?.id || 0 });
    if (res.status === 'success') {
      setReceipt(res.data);
      setPayment({ paid_amount: '', payment_mode: '', remarks: '' });
      await loadStudents(); await loadHistory();
    } else alert(res.message || 'Payment failed');
  };

  const printReceipt = () => {
    const html = document.getElementById('receipt-print').innerHTML;
    const w = window.open('', '', 'width=900,height=700');
    w.document.write(`<html><head><title>Receipt</title><style>body{font-family:Arial;padding:24px}.text-center{text-align:center}table{width:100%;border-collapse:collapse}td,th{border:1px solid #999;padding:8px}.d-flex{display:flex}.justify-content-between{justify-content:space-between}</style></head><body>${html}</body></html>`);
    w.document.close(); w.focus(); w.print(); w.close();
  };
  const setFilter = (k, v) => setFilters((p) => ({ ...p, [k]: v, page: 1 }));

  return (
    <div className="billing-page">
      <h3>Unified Billing</h3>
      <Row className="g-3">
        <Col lg={12}>
          <Card className="shadow-sm p-3">
            <Row>
              <Col md={4}><Form.Label>Student Type</Form.Label><Form.Select value={type} onChange={(e) => setType(e.target.value)}><option value="admission">Admission</option><option value="intern">Intern</option></Form.Select></Col>
              <Col md={8}>
    <Form.Label>Student</Form.Label>

   <Select
    placeholder="Search Student..."

    options={students.map((s) => ({
        value: s.id,
        label: `${s.name} | ${s.program_name}`,
        searchText: `${s.id} ${s.name} ${s.phone || ''} ${s.email || ''} ${s.program_name}`
    }))}

    value={
        students
            .map((s) => ({
                value: s.id,
                label: `${s.name} | ${s.program_name}`,
                searchText: `${s.id} ${s.name} ${s.phone || ''} ${s.email || ''} ${s.program_name}`
            }))
            .find((option) => String(option.value) === String(studentId)) || null
    }

    onChange={(option) =>
        setStudentId(option ? option.value : "")
    }

    filterOption={(option, inputValue) =>
        option.data.searchText
            .toLowerCase()
            .includes(inputValue.toLowerCase())
    }

    isSearchable
    isClearable
/>
</Col>
            </Row>
            {selected && <><Table bordered responsive className="mt-3"><tbody>
              <tr><th>{type === 'intern' ? 'Intern ID' : 'Student ID'}</th><td>{selected.id}</td><th>Name</th><td>{selected.name}</td></tr>
              <tr><th>Phone</th><td>{selected.phone || '-'}</td><th>Email</th><td>{selected.email || '-'}</td></tr>
              <tr><th>{type === 'intern' ? 'Internship Role' : 'Course'}</th><td>{selected.program_name}</td><th>{type === 'intern' ? 'Start Date' : 'Admission Date'}</th><td>{selected.joining_date}</td></tr>
            </tbody></Table><Row className="g-2"><Col md={3}><Card className="p-2"><small>Total Fee</small><strong>₹ {money(selected.total_fee)}</strong></Card></Col><Col md={3}><Card className="p-2"><small>Previously Paid</small><strong>₹ {money(selected.paid)}</strong></Card></Col><Col md={3}><Card className="p-2"><small>Current Balance</small><strong>₹ {money(selected.balance)}</strong></Card></Col><Col md={3}><Card className="p-2"><small>New Balance</small><strong>₹ {money(newBalance)}</strong></Card></Col></Row></>}
            <Row className="mt-3">
              <Col md={4}><Form.Label>Payment Amount</Form.Label><Form.Control type="number" min="1" value={payment.paid_amount} onChange={(e) => setPayment({ ...payment, paid_amount: e.target.value })} /></Col>
              <Col md={4}><Form.Label>Payment Mode</Form.Label><Form.Select value={payment.payment_mode} onChange={(e) => setPayment({ ...payment, payment_mode: e.target.value })}><option value="">Select</option><option>Cash</option><option>UPI</option><option>Card</option><option>Bank Transfer</option><option>Cheque</option></Form.Select></Col>
              <Col md={4}><Form.Label>Remarks</Form.Label><Form.Control value={payment.remarks} onChange={(e) => setPayment({ ...payment, remarks: e.target.value })} /></Col>
            </Row>
            <Button
              className="mt-3 billing-save-payment-btn"
              onClick={savePayment}
            >
              Save Payment
            </Button>
          </Card>
        </Col>
        <Col lg={12}>
          <Card className="shadow-sm p-3 billing-history-card">
            <div className="billing-history-head">
              <h5>Billing History</h5>
              <span>{history.length} records</span>
            </div>
            <Row className="g-2 mb-2 erp-filter-row">
              <Col md={6}><Form.Control placeholder="Search" value={filters.search} onChange={(e) => setFilter('search', e.target.value)} /></Col>
              <Col md={6}><Form.Select value={filters.student_type} onChange={(e) => setFilter('student_type', e.target.value)}><option value="">All</option><option value="admission">Admission</option><option value="intern">Intern</option></Form.Select></Col>
            </Row>
            <Row className="g-2 mb-3 erp-filter-row">
              <Col md={6}><Form.Control type="date" value={filters.from_date} onChange={(e) => setFilter('from_date', e.target.value)} /></Col>
              <Col md={6}><Form.Control type="date" value={filters.to_date} onChange={(e) => setFilter('to_date', e.target.value)} /></Col>
            </Row>
            <Table bordered hover responsive className="erp-table">
              <thead><tr><th>Bill</th><th>Date</th><th>Student</th><th>Type</th><th>Paid</th><th>Balance</th><th>View</th></tr></thead>
              <tbody>
                {history.length ? history.map((b) => <tr key={b.id}><td>{b.bill_no}</td><td>{b.bill_date}</td><td>{b.student_name}</td><td><Badge>{b.student_type}</Badge></td><td>{b.paid_amount}</td><td>{b.remaining_balance}</td><td><ActionIconButton size="sm" icon={faEye} label="View" onClick={() => setReceipt(b)} /></td></tr>) : (
                  <tr><td colSpan="7" className="text-center text-muted">No billing history found</td></tr>
                )}
              </tbody>
            </Table>
           {(pagination.total_pages || 1) > 1 && (
  <div className="d-flex justify-content-center align-items-center mt-3 gap-3">

    <Button
      variant="light"
      disabled={filters.page <= 1}
      onClick={() =>
        setFilters({
          ...filters,
          page: Math.max(1, filters.page - 1),
        })
      }
      style={{
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      ‹
    </Button>

    <span className="fw-semibold">
      {filters.page} / {pagination.total_pages || 1}
    </span>

    <Button
      variant="light"
      disabled={filters.page >= (pagination.total_pages || 1)}
      onClick={() =>
        setFilters({
          ...filters,
          page: Math.min(
            pagination.total_pages || 1,
            filters.page + 1
          ),
        })
      }
      style={{
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      ›
    </Button>

  </div>
)}
          </Card>
        </Col>
      </Row>
      <Modal show={!!receipt} onHide={() => setReceipt(null)} size="lg"><Modal.Body>{receipt && <div id="receipt-print"><div className="text-center"><img src={logo} alt="logo" style={{height:60}} /><h3>Semicolon Innovations</h3><p>Official Fee Receipt</p></div><div className="d-flex justify-content-between"><p><b>Bill No:</b> {receipt.bill_no}</p><p><b>Receipt No:</b> {receipt.receipt_no}</p><p><b>Date:</b> {receipt.bill_date}</p></div><Table bordered><tbody><tr><th>Student Type</th><td>{receipt.student_type}</td><th>Name</th><td>{receipt.student_name}</td></tr><tr><th>Phone</th><td>{receipt.phone}</td><th>Course / Internship</th><td>{receipt.program_name}</td></tr><tr><th>Total Fee</th><td>₹ {money(receipt.total_fee)}</td><th>Previously Paid</th><td>₹ {money(receipt.previous_paid)}</td></tr><tr><th>Current Payment</th><td>₹ {money(receipt.paid_amount)}</td><th>Remaining Balance</th><td>₹ {money(receipt.remaining_balance)}</td></tr><tr><th>Payment Mode</th><td>{receipt.payment_mode}</td><th>Collected By</th><td>{receipt.collected_by_name || user?.name}</td></tr><tr><th>Remarks</th><td colSpan="3">{receipt.remarks || '-'}</td></tr></tbody></Table><div className="text-end mt-5">Signature: ____________________</div></div>}</Modal.Body><Modal.Footer><ActionIconButton icon={faPrint} label="Print Bill" onClick={printReceipt} /><ActionIconButton variant="outline-secondary" icon={faFilePdf} label="Download PDF" onClick={printReceipt} /></Modal.Footer></Modal>
    </div>
  );
}

export default UnifiedBilling;